<template>
    <div class="grid-wrapper product-sale-banner">

        <a v-if="saleBanner.path" :href="saleBanner.path">
            <img :src="saleBanner.image_url" :alt="saleBanner.alternative_text" class="product-sale-banner__banner responsive desktop-only">
            <img :src="saleBanner.mobile_image_url || saleBanner.image_url" :alt="saleBanner.alternative_text" class="product-sale-banner__banner responsive mobile-only">
        </a>
        <template v-else>
            <img :src="saleBanner.image_url" :alt="saleBanner.alternative_text" class="product-sale-banner__banner responsive desktop-only">
            <img :src="saleBanner.mobile_image_url || saleBanner.image_url" :alt="saleBanner.alternative_text" class="product-sale-banner__banner responsive mobile-only">
        </template>


        <div class="product-sale-banner__categories" :style="gridTemplateColumnsStyle">
            <a v-for="childSlide in saleBanner.children_slides" :key="childSlide.id" :href="childSlide.path">
              <img :src="childSlide.image_url" :alt="childSlide.alternative_text" class="responsive">
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ProductsSaleBanner",
        props: {
            saleBanner: {
                type: Object
            }
        },
        computed: {
            gridTemplateColumnsStyle () {
                return {
                    'grid-template-columns': `repeat(${this.saleBanner.slides_per_row || 4}, 1fr)`
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/assets/stylesheets/variables.scss';

    .product-sale-banner {
        &__banner {
            margin-bottom: 15px;
        }

        &__categories {
            display: grid;
            grid-gap: 15px;
            align-items: center;
            justify-items: center;

            @media only screen and (max-width: $mobile-max) {
                grid-template-columns: repeat(2, 1fr) !important;
            }

            img {
                box-sizing: border-box;
            }
        }

        .desktop-only {
            @media (max-width: $mobile-max) {
                display: none;
            }
        }

        .mobile-only {
            @media (min-width: $desktop-min) {
                display: none;
            }
        }
    }
</style>
